import { SET_ROLES } from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const roles = (roles = {}, action: reduxStoreTypes.RolesAction) => {
    if (action.type === SET_ROLES) {
        return action.roles
    }
    return roles
}
export default roles